module.exports = __webpack_public_path__ + "img/course_hbs.7196cefb.jpg";